import type { JSX } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useQuery } from "urql";
import Loader from "../../shared/components/Loader";
import t from "../../shared/translations";
import ShowError from "../components/ShowError";
import LockedModal, { useLockedModal } from "../LockedModal";
import WithTasksSidebar from "../tasksSidebar";
import { query } from "./query";
import SubmittedTaskRoutes from "./SubmittedTaskRoutes";

function SubmittedTask(): JSX.Element {
    const location = useLocation();
    // Extract id from pathname: /submitted-task/123/... -> 123
    const id = location.pathname.split("/")[2];
    const { openLockedModal, ...lockedProps } = useLockedModal();
    const [result] = useQuery({
        query,
        variables: { id },
    });

    let main = <div />;
    if (result.fetching) {
        main = <Loader />;
    } else if (result.error) {
        main = <ShowError />;
    } else if (!result.data.submittedTask) {
        main = <Navigate to="/landing" replace={true} />;
    } else {
        const task = result.data.submittedTask;

        main = <SubmittedTaskRoutes task={task} />;
    }

    return (
        <>
            <WithTasksSidebar
                openLockedModal={openLockedModal}
                activeItem={result.data?.submittedTask?.learningPathItem?.id}
                mainLabel={t("player.submitted-task.tab-task")}
                big={true}
            >
                {main}
            </WithTasksSidebar>
            <LockedModal {...lockedProps} />
        </>
    );
}

export default SubmittedTask;
